import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'NOTIFICATIONS/WARNING';

export const {action: addWarnings} = createAction(`${domain}/ADD_WARNING`, warnings => ({warnings}));

export const {action: dismissWarning} = createAction(`${domain}/DISMISS_WARNING`, index => ({index}));
